module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "lio-company.51d21251.png";